import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from '@material-ui/core';
import Clientes from './Clientes';
import ClientesSubir from './ClientesSubir';
import ClientesReporte from './ClientesReporte';
import { DialogComponent } from '../../../components/dialog/DialogComponent';

const ClientesIndex = () => {
    const history = useHistory();
    const [reporteDialog, setReporteDialog] = useState(false);

    return (
        <div className="w-full p-4 md:p-6">
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-6">
                <div>
                    <h1 className="text-2xl font-bold text-gray-900 tracking-tight">Clientes</h1>
                    <p className="text-sm text-gray-500 mt-1">Catálogo general de clientes, crédito y contado</p>
                </div>
                <div className="flex flex-wrap items-center gap-2">
                    <ClientesSubir />
                    <Button
                        variant="outlined"
                        onClick={() => setReporteDialog(true)}
                    >
                        Reporte
                    </Button>
                    <Button
                        className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded-full shadow-md"
                        variant="contained"
                        color="primary"
                        onClick={() => history.push(`/Catalogo/Cliente`)}
                    >
                        + Nuevo Cliente
                    </Button>
                </div>
            </div>

            <Clientes />

            <DialogComponent
                open={reporteDialog}
                title="Reportes de clientes"
                onClose={() => setReporteDialog(false)}
            >
                <ClientesReporte />
            </DialogComponent>
        </div>
    );
};

export default ClientesIndex;
